export const FOOTER_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    label: "Link Label",
    slug: "",
    url: "https://example.com",
    priority: 1,
  },

  FOOTER_FIELDS_CONFIG: [
    {
      fieldName: "status",
      label: "Footer Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Footer Section",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "enable_footer_content",
      label: "Enable Footer Content",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Footer Content",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Scroll reveal on footer content",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "enable_copyright",
      label: "Enable Copyright",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Copyright",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "copyright_text",
      label: "Copyright Text",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter copyright text (e.g., © 2024 Company Name. All rights reserved.)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "copyright_text_color",
      label: "Copyright Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter copyright text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
  ],

  // Category fields configuration for Form_3
  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter category name (e.g., Quick Links, Resources, Contact)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "name_text_color",
      label: "Category Name Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter category name text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "order_index",
      label: "Display Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Category Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable category",
      defaultValue: true,
    },
  ],

  // Footer item table fields configuration for Form_3
  FOOTER_TABLE_FIELDS_CONFIG: [
    {
      header: "Label",
      fieldName: "label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter link label",
    },
    {
      header: "Slug",
      fieldName: "slug",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "slug for the link",
      required: false,
    },
    {
      header: "Label Color",
      fieldName: "label_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter label color (e.g., #000000)",
      required: false,
    },
    {
      header: "URL",
      fieldName: "url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter URL",
    },
    {
      header: "Description",
      fieldName: "description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter description",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority (1, 2, 3...)",
      required: true,
    },
  ],
};

